import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../Components/Header";
import NavBar from "../Components/NavBar";
import useAuth from "../useAuth";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";

export default function EntryPage() {
  const { user, menuOpen, changeMenuSize } = useAuth();
  const location = useLocation();
  const pathname = location.pathname.split("/")[2];

  if (!user) return <Navigate to="/login" />;

  return (
    <div className="min-h-screen flex bg-slate-100">
      {/* Sidebar Container */}
      <div
        className={`${
          menuOpen ? "w-72" : "w-20"
        } fixed top-0 left-0 h-screen bg-white border-r border-slate-200 shadow-sm transition-all duration-500 z-30`}
      >
        <div className="h-full overflow-y-auto no-scrollbar">
          <NavBar />
        </div>

        {/* Sidebar Toggle (Corporate Style) */}
        <button
          onClick={changeMenuSize}
          className="absolute top-1/2 -right-3 transform -translate-y-1/2 w-6 h-6 rounded-full 
                     bg-white border border-slate-300 shadow hover:bg-slate-200 flex items-center 
                     justify-center text-slate-700 transition-all"
        >
          {menuOpen ? (
            <RiArrowLeftSLine className="text-base" />
          ) : (
            <RiArrowRightSLine className="text-base" />
          )}
        </button>
      </div>

      {/* Main Content Area */}
      <div
        className={`transition-all duration-500 w-full ${
          menuOpen ? "ml-72" : "ml-20"
        }`}
      >
        <div className="sticky top-0 z-20">
          <Header />
        </div>

        <div className="p-4 min-h-screen text-slate-700">
          <Outlet />
        </div>

        {/* Footer */}
        {pathname !== "grievancesMsgs" && (
          <div className="px-4 py-4 border-t text-xs text-slate-600 mx-4 border-slate-300">
          </div>
        )}
      </div>
    </div>
  );
}
